import {DatePicker} from 'antd'
import React from 'react'

export type TableSearchDataFilterProps = {
  filterValue: string
  onFilterValueSet: (dates: [string, string]) => void
}

export function TableSearchDataFilter({onFilterValueSet, filterValue}: TableSearchDataFilterProps) {
  return (
    <DatePicker.RangePicker
      allowEmpty={[true, true]}
      onCalendarChange={(_dayjsDates, dates) => onFilterValueSet(dates)}
    />
  )
}
